<template>
    <div>
        <h1 style="font-size: 24px; color: black;">各项目公摊费用分摊表</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="应用：">
                    <el-select v-model="queryData.appId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="app in appList"
                                   :key="app.appId"
                                   :label="app.appName"
                                   :value="app.appId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份：">
                    <el-date-picker
                            unlink-panels
                            v-model="queryData.timeDate"
                            type="monthrange"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table border max-height="550"
                      :data="list">
                <el-table-column  label="月份"  align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.dt,"yyyy-MM")}}
                    </template>
                </el-table-column>
                <el-table-column  label="业务组"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.deptId | commonFilter(deptObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="项目产品"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.appId | commonFilter(appObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="活跃用户累计"  prop="activeUser" align="center" ></el-table-column>
                <el-table-column  label="分摊费用"  prop="shareCost" align="center" ></el-table-column>
                <el-table-column  label="服务器费用"  prop="serverCost" align="center" ></el-table-column>
                <el-table-column  label="总消耗费用"  prop="cost" align="center" >
                    <template slot-scope="scope">
                        {{scope.row.serverCost + scope.row.shareCost}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>

    </div>
</template>

<script>
    import settingMix from '@/utils/mix/common-setting';
    import {searchAppSharedExpensesShare} from "@/http/financialApi";
    import utils from '@/utils';
    import DateUtil from '@/utils/DateUtil'
    export default {
        name: "AppSharedExpensesShare",
        mixins: [settingMix],
        data(){
            return{
                needGetApp: true,
                needDept:true,
                list:[],
                labelWidth: '150px',
                queryData: {
                    timeDate:['',''],
                    appId: -1
                },
                appList:[],
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            search() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchAppSharedExpensesShare(this.queryData).then(resp => {
                    this.list = resp.data.info.content;
                    this.page.totalElements = resp.data.info.total
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            initDateRange() {
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(1)
            }
        },
        created() {
            this.search();
            this.initDateRange()
        }
    }
</script>

<style scoped>

</style>